<template>
  <div class="documents-uploader">
    <div class="documents-uploader-header">
      <div class="documents-uploader-info">
        <div class="documents-uploader-title">{{ title }}</div>
        <div class="documents-uploader-hint">{{ hint }}</div>
      </div>
      <input
        ref="fileInput"
        type="file"
        class="documents-uploader-input"
        :accept="acceptedFileTypes"
        @change="onFileSelect"
      />
      <button
        type="button"
        class="documents-uploader-btn"
        :disabled="isAttachDisabled"
        @click="triggerFileInput"
      >
        <span>{{ attachBtn }}</span>
        <img
          src="../../../public/custom/images/attach.svg"
          alt=""
        />
      </button>
    </div>
    <div v-if="files.length" class="documents-uploader-list">
      <div
        v-for="(item, index) in files"
        :key="item.id"
        class="documents-uploader-item"
      >
        <div class="documents-uploader-item-info">
          <div class="documents-uploader-item-name">{{ item.name }}</div>
          <div class="documents-uploader-item-size">{{ item.sizeLabel }}</div>
        </div>
        <img
          class="documents-uploader-item-remove"
          src="../../../public/custom/images/trash.svg"
          alt=""
          @click="removeFile(index)"
        />
      </div>
    </div>
  </div>
</template>

<script>
const FILE_MAX_SIZE = 10 * 1024 * 1024;

export default {
  name: 'SignUpDocumentsUploader',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      required: true,
    },
    hint: {
      type: String,
      required: true,
    },
    attachBtn: {
      type: String,
      required: true,
    },
    maxFiles: {
      type: Number,
      required: true,
    },
    acceptedFileTypes: {
      type: String,
      default: '',
    },
    filePattern: {
      type: RegExp,
      default: null,
    },
  },
  data() {
    return {
      fileId: 0,
    };
  },
  computed: {
    files() {
      return this.value;
    },
    isAttachDisabled() {
      return this.files.length >= this.maxFiles;
    },
  },
  methods: {
    triggerFileInput() {
      if (!this.isAttachDisabled) {
        this.$refs.fileInput.click();
      }
    },
    onFileSelect(event) {
      const file = event.target.files[0];

      event.target.value = '';

      if (!file || this.isAttachDisabled) {
        return;
      }

      if (this.isFileInvalid(file)) {
        this.$toast.error(this.$t('message.docksUploader.validationErrorMsg'));
        return;
      }

      const nextFiles = [
        ...this.files,
        {
          id: ++this.fileId,
          file,
          name: file.name,
          sizeLabel: this.formatFileSize(file.size),
        },
      ];

      this.$emit('input', nextFiles);
    },
    isFileInvalid(file) {
      return file.size > FILE_MAX_SIZE || (this.filePattern && !this.filePattern.test(file.name));
    },
    removeFile(index) {
      const nextFiles = this.files.filter((_, itemIndex) => itemIndex !== index);

      this.$emit('input', nextFiles);
    },
    formatFileSize(size) {
      return `${Math.round(size / 1024)} KB`;
    },
  },
};
</script>

<style lang="scss" scoped>
.documents-uploader {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 10px;
}

.documents-uploader-header {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
}

.documents-uploader-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px 0;
}

.documents-uploader-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}

.documents-uploader-hint {
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #878787;
}

.documents-uploader-input {
  display: none;
}

.documents-uploader-btn {
  flex-shrink: 0;
  height: 40px;
  padding: 8px 11px 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  border-radius: 8px;
  background-color: #41bf7b;
  cursor: pointer;

  span {
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: #ffffff;
  }

  img {
    width: 24px;
    height: 24px;
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
}

.documents-uploader-list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 0;
}

.documents-uploader-item {
  width: 222px;
  max-width: 100%;
  padding: 6px 8px 6px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background-color: #f9f9f9;
  box-sizing: border-box;
}

.documents-uploader-item-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.documents-uploader-item-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #01273b;
}

.documents-uploader-item-size {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #7a7a7a;
}

.documents-uploader-item-remove {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  cursor: pointer;
}
</style>
